import Handlebars from 'hbs';

import Component from './component';

import DatePicker from '../vendor/calendar.js';

Handlebars.registerHelper('dayHelper', function (str) {
    var days = {
        0: "Sun",
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat"
    }
    return days[str];
});

Handlebars.registerHelper('timeHelper', function (str) {
    return str.slice(0, 2) + ":" + str.slice(2);
    ;
});

export default class KissSlots extends Component {

    constructor() {

        super();
        this.init();    

    }

    init() {

        this.initCalendar();
        this.events();
        
    }

    events() {

       var $this = this

       $('#kab-appointment-date').on('change', function(){

            setTimeout(function () {

                $this.setSlots();

            }, 150);

        });
       
       /**document.body.addEventListener("mousedown", function (e) {
            if (e.target.classList.contains("qs-square") || e.target.classList.contains("qs-num")) {
                setTimeout(function () {

                    $this.setSlots();

                }, 150);
            }
        });**/

    }

    initCalendar() {
        // ==========================================================================
        // Calendar
        // ==========================================================================

        var datePickerElement = '<input type="text" readonly="readonly" autocomplete="off" id="kab-appointment-date" class="kab__modal_calendar--input">';

        $('.kab__modal_calendar_input').html(datePickerElement);

        var minDateObj = new Date();
        minDateObj.setDate(minDateObj.getDate() + 3);
        var maxDateObj = new Date();
        maxDateObj.setDate(maxDateObj.getDate() + 16);

        

        const picker = DatePicker('.kab__modal_calendar--input', {
            onSelect: (instance, date) => {
                // TODO stuff when a date is selected (or unselected) on the calendar.
            },
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString('en-GB', {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit'
                });
                input.value = value; // => '01 Nov 2018'

                $('#kab-appointment-date').trigger('change');

            },
            disableYearOverlay: true

        });

        picker.setMin(minDateObj);
        picker.setMax(maxDateObj);


        // set the current day
        picker.setDate(minDateObj, true);
       

        this.setSlots();
    }

    setSlots() {

        

        const nth = function(d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1:  return "st";
                case 2:  return "nd";
                case 3:  return "rd";
                default: return "th";
            }
        }

        /** Date formate to backend server **/
        const dateformateser = function(dateObj) {
            const month=((dateObj.getMonth()+1)>=10)? (dateObj.getMonth()+1) : '0' + (dateObj.getMonth()+1);
            const date=((dateObj.getDate())>=10)? (dateObj.getDate()) : '0' + (dateObj.getDate());
            const formatedDate = dateObj.getFullYear() +''+ month +''+ date;
            return formatedDate;
        }

        /** Date formate to Display in front end **/
        const dateformatedis = function(dateObj) {
            const day = dateObj.toString().split(' ')[0];
            const date = dateObj.getDate();
            const month = dateObj.toLocaleString('default', { month: 'short' });
            const formatedDate = `${day} ${date}<sup>${nth(date)}</sup> ${month}`;
            return formatedDate;
        }

        Date.prototype.addDays = function(days) {
            this.setDate(this.getDate() + parseInt(days));
            return this;
        };


        var slotsbyDate = [];

        var calDate = $('#kab-appointment-date').val();

        var selectedDate = new Date(calDate);
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
        currentDate.setHours(0, 0, 0, 0);


        $(".kab__modal_calendar-loading").hide();
        $(".kab__modal_calendar-loading").find("p").text("");


        // If the user selected date is past date
        if (selectedDate.getTime() < currentDate.getTime()) {
       
            $(".kab__modal_calendar-loading").show();
            $(".kab__modal_calendar-loading").find("img").hide();
            $(".kab__modal_calendar-loading").find("p").text("Please select the valid appointment date.");

        } else {


            const dateAfterThreeDays = new Date();
            const dateAfterThreeDaysTS = dateAfterThreeDays.setDate(currentDate.getDate()+3);


            // Slots needs to be shown from three days after the current date
            if (selectedDate.getTime() < dateAfterThreeDaysTS) {
                selectedDate = new Date(dateAfterThreeDaysTS)
            }


            // Slots need to show for next 14 days to date after three days of current date
            const maxSlotAvailableDateTS = dateAfterThreeDays.setDate(dateAfterThreeDays.getDate()+13);


            var increment = 0;
            for (var day = 0; day < 7; day++) {

                var dateSlots = {};
                var selectedDateTS = selectedDate.addDays(increment);
                var date = dateformatedis(selectedDateTS);
                if (date.indexOf('Sat') == -1 && date.indexOf('Sun') == -1) {

                    dateSlots['date'] = dateformatedis(selectedDateTS);
                    dateSlots['formatedDate'] = dateformateser(selectedDateTS);
                    dateSlots['slots'] = "";
                    if (selectedDateTS <= maxSlotAvailableDateTS) {
                        dateSlots['slots'] = ['AM','PM'];
                    }
                
                    slotsbyDate.push(dateSlots);

                } else {

                    day--


                }

                increment = 1;
            }


            this.populateDays(slotsbyDate);
        }


        //var sbdJsonString = JSON.stringify(slotsbyDate);

        //console.log(sbdJsonString);


    }



    populateDays(slotsbyDate) {

        const $this = this;
        
        for (var day = 1; day < slotsbyDate.length + 1; day++) {
            
            var dayContainer = document.getElementById("kab__day" + day);
            dayContainer.innerHTML = slotsbyDate[day - 1].date;

            var timesContainer = document.getElementById("kab__day" + day + "container");

            while (timesContainer.firstChild) {
                timesContainer.removeChild(timesContainer.firstChild);
            }

            for (var slot = 0; slot < slotsbyDate[day - 1].slots.length; slot++) {

                //clear out all previous elements

                var slotContainer = document.createElement("div");
                slotContainer.classList.add("time");
                $(slotContainer).data("dateFormatted", slotsbyDate[day - 1].formatedDate);
                slotContainer.innerText = slotsbyDate[day - 1].slots[slot]; 
                timesContainer.appendChild(slotContainer);

            }

            if (timesContainer.children.length == 0) {
                var nullMsg = document.createElement("div");
                nullMsg.innerText = "No slots";
                // nullMsg.classList.add("null");
                nullMsg.classList.add("no-slots");
                timesContainer.appendChild(nullMsg);
            }

        }

        $('.kab__modal_calendar--timeselection-inner .time').off('click').on('click', function () {
            
            $('.time').removeClass('slot-selected');
            $(this).toggleClass('slot-selected');
            //$('#next-button.kab__modal_form--btn-grey').hide();
            //$('#next-button-active.kab__modal_form--btn-blue').show();
            $('#selected-appointment-date').val($(this).data('dateFormatted'));
            $('#selected-appointment-time').val(this.innerText);
            $('#selected-appointment-time').trigger('input');

        });

        $(".kab__modal_calendar--timeselection-inner").each(function() {

            this.addEventListener("scroll",function(e){
                //console.log(this, this.offsetHeight + this.scrollTop == this.scrollHeight);
                if(this.offsetHeight + this.scrollTop == this.scrollHeight){
                    if(this.nextElementSibling.classList.value == "cont"){
                        this.nextElementSibling.style.display = "none";
                    }
                }
                else{
                    if(this.nextElementSibling.classList.value == "cont"){
                        this.nextElementSibling.style.display = "";
                    }
                }
            });

            this.dispatchEvent(new Event("scroll"));

        });

    }      



    getSlots() {

        return this.kissSlots;

    }

}